// COMPONENTS
import InfoBar from "../infoBar.component";
import CountInfoTag from "../infoTags/count.infoTag.infoBar.component";

const CustomerInfoBar = ({
  metaData = { totalCount: 0 },
}) => {
  return (
    <InfoBar>
      <CountInfoTag>Customer Count: {metaData?.totalCount || 0}</CountInfoTag>
    </InfoBar>
  );
};

export default CustomerInfoBar;
